import React from "react";
import useConvertProgress, { formatDuration, resolveConvertPercent } from "../hooks/useConvertProgress";

export default function ConvertInlineBar({
  token,
  videoId,
  enabled = true,
  label = "",
  compact = false,
}) {
  const info = useConvertProgress(token, videoId, enabled && Boolean(videoId));
  if (!enabled || !videoId) return null;

  const percent = resolveConvertPercent(info, { status: info.status });
  const failed = info.status === "failed" || info.phase === "failed";
  const ready = info.status === "ready" || percent >= 100;

  return (
    <div className={`convert-inline ${compact ? "compact" : ""} ${failed ? "failed" : ""}`}>
      {label ? <p className="convert-inline-label">{label}</p> : null}
      <div
        className="convert-bar convert-inline-bar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
      >
        <span style={{ width: `${ready ? 100 : percent}%` }} />
      </div>
      <div className="convert-inline-meta">
        <strong>{ready && !failed ? "100%" : `${percent}%`}</strong>
        <span>
          {failed
            ? info.error_message || info.message || "Error"
            : info.message || "Convirtiendo…"}
          {info.elapsed != null && !failed && !ready
            ? ` · ${formatDuration(info.elapsed)}`
            : ""}
          {info.eta != null && !failed && !ready && percent > 5
            ? ` · ~${formatDuration(info.eta)} rest.`
            : ""}
        </span>
      </div>
    </div>
  );
}
